module.exports = __webpack_public_path__ + "img/BestOfQuarterDigitalIllustration.35040edc.jpg";